import React from "react";
import { NavLink } from "react-router-dom";
import Button from "../../components/button/button";
import ActivitiesContainer from "./activities-container";

// import "./NavigationItems.css";
import "./activities.css";

function ActivitiesItems(props) {
  return (
    <li>
      <div className="activities-item">
        <div className="activitie-top">
          <h3>{props.name}</h3>
          <p>{props.description}</p>
        </div>
        <div>
          {props.isAuth && (
            <>
              <Button design="flat" mode="danger" onClick={props.onDelete}>
                Delete
              </Button>
              <Button design="flat" onClick={props.onStartEdit}>
                Edit
              </Button>
            </>
          )}
        </div>
      </div>
    </li>
  );
  // props.isAuth && (
  //   <li className="navigation-item" key="logout">
  //     <button onClick={props.onLogout}>Logout</button>
  //   </li>
  // ),
}

export default ActivitiesItems;
